import $ from 'jquery';

let $body = $(document.body);
let rlogIds = [];

// Log rlogids in the DOM for AJAX requests so automation tests can pick up the values
$(document).ajaxComplete(function (event, xhr) {
	let pageInfo = xhr.responseJSON && xhr.responseJSON.sys && xhr.responseJSON.sys.pageInfo,
		hostName = pageInfo && pageInfo.hostName,
		rlogId = pageInfo && pageInfo.rlogId;

	// Store the last 5 rlogIds
	if (rlogId) {
		rlogIds.unshift(rlogId);
		rlogIds = rlogIds.slice(0, 5);
	}

	// Add them to the body in a data-attr where automation can pick up the values for logging
	$body.data('logid', JSON.stringify(rlogIds))
		.data('hostname', hostName);
});



// WEBPACK FOOTER //
// ./lib/rlogid.es6